import { useRouter } from 'next/router';
import Link from 'next/link';
import { useEffect } from 'react';
import { useTheaterMode } from '../context/TheaterModeContext';
import Tippy from '@tippyjs/react';
import 'tippy.js/dist/tippy.css'; // Import Tippy.js CSS

const LangButton = () => {
    const router = useRouter();
    const activePath = router.asPath;
    const isFrench = activePath.startsWith(`/fr`);
    const isDisplay =     activePath.startsWith(`/fr/accueil`) ||
                          activePath.startsWith(`/fr/favoris`) ||
                          activePath.startsWith(`/en/favorites`) ||
                          activePath.startsWith(`/en/home`)
                    ;

    const { theaterMode } = useTheaterMode();

    useEffect(() => {
        const language = isFrench ? 'French' : 'English';
        localStorage.setItem('userLanguage', language);
    }, [isFrench]);

    if (!isDisplay) {
        return null;
    }

    return (
        <>
            {isFrench ? (

                <Link href='/en/home'>
                    <Tippy  className="customTooltip" content="Visit Sunulife in English" placement='left'>
                        <div className={theaterMode ? "langButton" : "langButton-light"}>EN</div>
                    </Tippy>
                </Link>

            ) : (
                <Link href='/fr/accueil'>
                    <Tippy  className="customTooltip" content="Visitez Sunulife en Français" placement='left'>
                        <div className={theaterMode ? "langButton" : "langButton-light"}>FR</div>
                    </Tippy>
                </Link>
            )}
        </>
    );
};

export default LangButton;